export default __webpack_public_path__ + "static/media/Location_Bremen.8cc21d33.svg";